import type { FilterOptions, FilterState, KpiItem } from "./types";

export const STATIC_FILTER_OPTIONS = {
  dataSource: [
    { label: "Автосбор", value: "auto" },
    { label: "Ручной ввод", value: "manual" },
    { label: "Импорт файла", value: "import" },
  ],
  room: [
    { label: "Стандарт 2-местный", value: "std2" },
    { label: "Делюкс", value: "deluxe" },
    { label: "Семейный", value: "family" },
  ],
};

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  category: [],
  ota: [],
  meals: [],
  refund: [],
  payment: [],
  competitors: [],
  dataSource: [],
  room: [],
};

export const DEFAULT_FILTERS: FilterState = {
  dataSource: [],
  category: [],
  ota: [],
  meals: [],
  refund: [],
  payment: [],
  competitor: [],
  date: "",
  dateIntervalFrom: "",
  dateIntervalTo: "",
  dayType: "",
  hotel: "",
  room: [],
};

export const DEFAULT_KPI: KpiItem[] = [
  {
    label: "Средняя дельта",
    value: "—",
    description: "к средним ценам конкурентов",
    accent: "emerald",
  },
  {
    label: "Средняя цена клиента",
    value: "—",
    description: "по выбранному периоду",
    accent: "indigo",
  },
  {
    label: "Средняя цена конкурентов",
    value: "—",
    description: "по выбранному периоду",
    accent: "violet",
  },
  {
    label: "Дней когда конкурент выше/ниже",
    value: "—",
    description: "дней с отклонением",
    accent: "amber",
  },
];

export const CHART_PALETTE = ["#86efac", "#22c55e", "#16a34a", "#c4b5fd", "#8b5cf6", "#6d28d9"];

export const CHART_SERIES_COLORS = {
  client: {
    min: "#86efac",
    avg: "#22c55e",
    max: "#16a34a",
  },
  competitor: {
    min: "#c4b5fd",
    avg: "#8b5cf6",
    max: "#6d28d9",
  },
} as const;
